// CommonCodeGql.js
import { gql } from "@apollo/client";
import { DC_INFO_LIST_PART } from "../dc_info/DcInfoGql";

const COMMON_CODE = gql`
fragment CommonCode on CommonCode {
    codeGp
    codeId
    codeName
    oldCodeId
    code1
    code2
    code3
    code4
    code5
    code6
    code7
    code8
    code9
    code10
    flag1
    flag2
    content
    regDate
    regUser
}
`;

const COMMON_CODE_GROUP = gql`
${COMMON_CODE}
fragment CommonCodeGroup on CommonCodeGroup {
    codeGp
    codeGpNm
    codes {
        ...CommonCode
    }
}
`;

export const COMMON_CODE_TREE = gql`
${COMMON_CODE_GROUP}
query CommonCodeTree {
    commonCodeTree {
        ...CommonCodeGroup
    }
}
`;

export const LIST_COMMON_CODE = gql`
${COMMON_CODE}
query ListCommonCode {
    commonCodeList {
        ...CommonCode
    }
}
`;

// 2개 묶어서 query

const AUTH_TABLE_LIST_PART = gql`
fragment AuthTableListPart on AuthTable {
    jobName
    authClassId
    jobComment
    allowUse
    regDate
    regUser
}
`;

export const CODE_TREE_AND_AUTH_TABLE = gql`
${COMMON_CODE_GROUP}
${AUTH_TABLE_LIST_PART}
${DC_INFO_LIST_PART}
query CodeTreeAndAuthTable {
    commonCodeTree {
        ...CommonCodeGroup
    }
    authTableList {
        ...AuthTableListPart
    }
    dcInfoList {
        ...DcInfoListPart
    }
}
`;



/*

extend type Query {
	commonCodeTree: [CommonCodeGroup]!
}

type CommonCode {
	codeGp: String
	codeId: String
	codeName: String
	oldCodeId: String
	code1: String
	code2: String
	code3: String
	code4: String
	code5: String
	code6: String
	code7: String
	code8: String
	code9: String
	code10: String
	flag1: String
	flag2: String
	content: String
}

type CommonCodeGroup {
    codeGp: String!
    codeGpNm: String
    codes: [CommonCode]
}



query {
  commonCodeTree {
    codeGp
    codeGpNm
    codes {
      codeId
      codeName
      codeGp
    }
  }
}

*/